<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div>
    <app-input-text [control]="form.get('countryPrefix')" name="port_number_countryPrefix"></app-input-text>
    <app-input-text [control]="form.get('areaCode')" name="port_number_areaCode" [placeholder]="areaCodePlaceholder" [autoFocus]="true"></app-input-text>
    <app-input-text [control]="form.get('number')" name="port_number_mainNumber" placeholder="port_number_mainnumber_placeholder"></app-input-text>
    <app-input-text [control]="form.get('start')" name="port_number_blockStart" placeholder="port_number_blockstart_placeholder"></app-input-text>
    <app-input-text [control]="form.get('end')" name="port_number_blockEnd" placeholder="port_number_blockend_placeholder"></app-input-text>
    <app-input-text [control]="form.get('previewStart')" name="port_number_previewFrom"></app-input-text>
    <app-input-text [control]="form.get('previewEnd')" name="port_number_previewTo"></app-input-text>
  </div>
  <div class="d-flex justify-content-end mt-3">
    <ng-content></ng-content>
    @if (!!submitButtonLabel) {
      <app-button-submit [invalid]="form.invalid" [label]="submitButtonLabel"></app-button-submit>
    }
  </div>
</form>
